import React from 'react';
import Badge from '../Badge';
import { ReactComponent as HighIcon } from 'src/assets/icons/ellipse-high-score.svg';
import { ReactComponent as UnfitIcon } from 'src/assets/icons/ellipse-unfit-score.svg';
import { ReactComponent as MediumIcon } from 'src/assets/icons/ellipse-medium-score.svg';
import { ReactComponent as LowIcon } from 'src/assets/icons/ellipse-low-score.svg';

import cx from 'classnames';

type BadgeFitmentProps = {
  onClick?: () => void;
  type: 'high' | 'low' | 'unfit' | 'medium' | 'N/A' | 'Yes' | 'No' | string | undefined;
  extraStyles?: any;
};
function BadgeFitment({ onClick, type, extraStyles = [] }: BadgeFitmentProps) {
  const normalizedType = typeof type === 'string' ? type.toLowerCase() : type;
  const getIcon = (badgeType: typeof type) => {
    switch (badgeType) {
      case 'high':
        return <HighIcon />;
      case 'low':
        return <LowIcon />;
      case 'unfit':
        return <UnfitIcon />;
      case 'medium':
        return <MediumIcon width={12} height={12} viewBox="0 0 12 12" />;
      default:
        return null;
    }
  };

  const fitmentBadgeClasses = cx({
    'badge-fitment': true,
    'badge-fitment-hover': onClick,
    'badge-fitment-high': normalizedType === 'high' || normalizedType === 'yes',
    'badge-fitment-unfit': normalizedType === 'low' || normalizedType === 'no',
    'badge-fitment-low': normalizedType === 'unfit',
    'badge-fitment-medium': normalizedType === 'medium',
  });

  return (
    <Badge
      className={fitmentBadgeClasses}
      style={{ ...extraStyles }}
      icon={getIcon(normalizedType)}
      content={type}
      onClick={onClick}
    />
  );
}

export default BadgeFitment;
